"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _foxButton = _interopRequireDefault(require("./fox-button"));
var _default = exports["default"] = _foxButton["default"];